import {
    CASH_ITEM_TRANSACTION_TYPE_LABELS,
    TransactionType,
} from "@common/types/transaction";

export enum BankCashItemType {
    CHECK = "check",
    DEPOSIT = "deposit",
}

export const BANK_CASH_ITEM_TYPE_LABELS: Record<BankCashItemType, string> = {
    [BankCashItemType.CHECK]:
        CASH_ITEM_TRANSACTION_TYPE_LABELS[TransactionType.CHECK],
    [BankCashItemType.DEPOSIT]:
        CASH_ITEM_TRANSACTION_TYPE_LABELS[TransactionType.DEPOSIT],
};

export interface BankCashItemBase {
    id: string;
    transactionId: number;
    type: BankCashItemType;
    checkNumber: string | null;
    reconciledAt: Date | null;
    createdAt: Date;
    updatedAt: Date;
}

export type BankCashItem = BankCashItemBase;
